import React from 'react';

const NotFound: React.FC = () => <h1>Page not found</h1>;

export default NotFound;
